import { EssayPilotService } from './../../services/essay-pilot/essay-pilot.service';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UtilityService } from './../../services/utility/utility.service';
import { InstituteService } from '../../services/institute/institute.service';
import { countryResponse } from '../../models/country/countryResponse';
import { Institute } from '../../models/institute/randomInstituteResponse';
import { ButtonModule } from 'primeng/button';
import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SetCheckListComponent } from "./set-check-list/set-check-list.component";
import { AddInstituteQuestionsComponent } from "./add-institute-questions/add-institute-questions.component";
import { ManageAgentsComponent } from "./manage-agents/manage-agents.component";
import { EssayQuestionResponse } from '../../models/essay-pilot/essayQuestionResponse';
import { InstituteCheckListDTO } from '../../models/institute/checkList/instituteCheckListDto';
import { Course } from '../../models/enums/enums';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { SearchInstituteResponse } from '../../models/institute/searchInstituteResponse';
import { InstituteCommonDetailsResponse } from '../../models/institute/instituteCommonDetailsResponse';
import { Router } from '@angular/router';
import { CourseLevelEnum } from '../../models/enums/courseLevelEnum';
import { TooltipModule } from 'primeng/tooltip';
import { CollegeSearchStateService } from '../../services/college-search-state/college-search-state.service';
enum Action {
  None,
  AddCheckList,
  EssayQuestions,
  Agents
}

@Component({
  selector: 'app-edit-manage-colleges',
  standalone: true,
  imports: [
    ButtonModule,
    AutoCompleteModule,
    TableModule,
    DropdownModule,
    DialogModule,
    InputTextareaModule,
    InputTextModule,
    CommonModule,
    FormsModule,
    SetCheckListComponent,
    AddInstituteQuestionsComponent,
    ManageAgentsComponent,
    TooltipModule
  ],
  templateUrl: './edit-manage-colleges.component.html',
  styleUrls: ['./edit-manage-colleges.component.scss']
})
export class EditManageCollegesComponent implements OnInit {

  @ViewChild('essayChild') essayChild?: any;

  action = Action;
  visible: boolean = false;
  countries: countryResponse[] = [];
  selectedCountry: string | null = null;
  isLoading: boolean = false;
  isCheckListLoader: boolean = false;
  isEssayPilotLoader: boolean = false;
  checkList: InstituteCheckListDTO | undefined;
  institutes: InstituteCommonDetailsResponse[] = [];
  total: number = 0;
  first: number = 0;
  rowSize: number = 10;
  currentAction: Action = Action.None;
  selectedInstitute: InstituteCommonDetailsResponse | null | undefined;
  essayQuestions: EssayQuestionResponse | undefined;

  searchAutoCompleteInstitutes: any;
  collegeName: any = '';


  constructor(
    private utilityService: UtilityService,
    private instituteService: InstituteService,
    private essayPilotService: EssayPilotService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private searchState: CollegeSearchStateService
  ) { }

  ngOnInit(): void {
    this.loadCountries();
    this.restoreState();
  }
isRestored: boolean = false;
private saveState(): void {
  this.searchState.save({
    selectedCountry: this.selectedCountry,
    collegeName: this.collegeName,
    first: this.first,
    rowSize: this.rowSize,
  });
}

private restoreState(): void {
  const s = this.searchState.state;
  if (!s) return;
  this.searchState.clear();   // ik vaari use karke clear
  this.selectedCountry = s.selectedCountry;
  this.collegeName = s.collegeName;
  this.first = s.first;
  this.rowSize = s.rowSize;
  this.searchInstitutes(Math.floor(this.first / this.rowSize) + 1);
}



  showDialog(institute: InstituteCommonDetailsResponse, selectedAction: Action) {
    this.selectedInstitute = institute;
    if (selectedAction == this.action.AddCheckList) {
      this.loadCheckList(institute);
    }
    else if (selectedAction == this.action.Agents) {
      this.currentAction = this.action.Agents;
      this.visible = true;
    }
    else {
      this.loadEssayPilotQuestions(institute);
    }
  }

  filterInstitutes(event: AutoCompleteCompleteEvent): void {
    if (event.query.length > 3) {
      this.instituteService.searchInstitute(event.query).subscribe({
        next: (response: SearchInstituteResponse[]) => {
          this.searchAutoCompleteInstitutes = response.length > 0 ? response : [{ name: event.query }];
        }
      });
    } else {
      this.searchAutoCompleteInstitutes = [{ name: event.query }];
    }
  }

  loadEssayPilotQuestions(institute: InstituteCommonDetailsResponse) {
    // this.isEssayPilotLoader=true;
    // this.essayQuestions = undefined;
    // this.essayPilotService.getInstituteQuestions({
    //   instituteId: institute.id,
    //   courseLevel: CourseLevelEnum.BachelorsDegree,
    //   courseName: ''
    // }).subscribe({
    //   next:(respose)=>{
    //     this.essayQuestions=respose;
    //     this.isEssayPilotLoader=false;
    //   },
    //   error:(error)=>{
    //     console.warn(`error while retriving checklist:${error}`);
    //     this.isEssayPilotLoader=false;
    //   }
    // });
    this.currentAction = this.action.EssayQuestions;
    this.visible = true;
  }

  loadCheckList(institute: InstituteCommonDetailsResponse) {
    this.visible = true;
    this.currentAction = this.action.AddCheckList;
    // this.instituteService.getCheckList({
    //   instituteId:institute?.id,
    //   courseLevel: CourseLevelEnum.BachelorsDegree,
    //   courseName: ''
    // }).subscribe({
    //   next: (result) => {
    //     this.checkList = result;
    //     this.currentAction = this.action.AddCheckList;
    //     this.visible = true;
    //     this.isCheckListLoader = false;
    //   },
    //   error: (error) => {
    //     console.warn(`error while retriving checklist:${error}`);
    //   }
    // });
  }


  private loadCountries(): void {
    this.utilityService.getCountries().subscribe({
      next: (response) => {
        if (response?.result) {
          this.countries = response.result;
        }
      },
      error: (err) => console.warn('Error loading countries:', err),
    });
  }

  searchInstitutes(pageNumber: number): void {
  const searchText = this.getSearchText();

  // Need at least one filter
  if (!this.selectedCountry && !searchText) return;

  this.isLoading = true;
  this.instituteService
    .listInstitutesByCountryAndSearchText({
      country: this.selectedCountry ?? null,
      searchText: searchText,
      pageNumber: pageNumber,
      pageSize: this.rowSize,
    })
    .subscribe({
      next: (response) => {
        this.isLoading = false;
        this.institutes = response.result ?? [];
        this.total = response.total ?? 0;
        // this.saveState();
          if (!this.selectedCountry && this.institutes.length > 0) {
    const countryName = this.institutes[0].countryName;
    if (countryName) {
      this.selectedCountry = countryName;
    }
  }
      },
      error: (error) => {
        console.warn('Error in searching institutes', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      complete: () => {
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
}

private getSearchText(): string | null {
  // collegeName is an object when a suggestion is picked, a string when typed freely
  const value = typeof this.collegeName === 'string'
    ? this.collegeName
    : this.collegeName?.name;
  return value?.trim() || null;
}

  // searchInstitutes(pageNumber: number): void {
  //   if (!this.selectedCountry) return;

  //   this.isLoading = true;
  //   console.log(this.collegeName);
  //   this.instituteService
  //     .listInstitutesByCountryAndSearchText({
  //       country: this.selectedCountry,
  //       searchText: this.collegeName.name ?? null,
  //       pageNumber: pageNumber,
  //       pageSize: this.rowSize,
  //     })
  //     .subscribe({
  //       next: (response) => {
  //         this.isLoading = false;
  //         this.institutes = response.result ?? [];
  //         this.total = response.total ?? 0;
  //       },
  //       error: (error) => {
  //         console.warn('Error in searching institutes', error);
  //         this.isLoading = false;
  //         this.cdr.detectChanges();
  //       },
  //       complete: () => {
  //         this.isLoading = false;
  //         this.cdr.detectChanges();
  //       },
  //     });
  // }

  onLazyLoad($event: TableLazyLoadEvent): void {
    const pageNumber = Math.floor(($event.first ?? 0) / ($event.rows ?? this.rowSize)) + 1;
    this.first = $event.first ?? 0;
    this.rowSize = $event.rows ?? this.rowSize;
    this.searchInstitutes(pageNumber);
  }
  closeDialog() {
    this.visible = false;
    this.currentAction = this.action.None;
  }

  addCollege() {
    this.saveState();
    this.router.navigate(['/admin/add-college']);
  }

  editCollege(id: string) {
    this.saveState();
    this.router.navigate(['/admin/add-college', id]);
  }
}
